export function validateNullOrBlank(rule, value, callback) {
  if (value != undefined) {
    value = value.toString().replace(/\s+/g, "");
    if (value == '' || value == null) {
      callback(new Error(rule.message || '必输项不能为空'));
    } else {
      callback();
    }
  } else {
    callback(new Error(rule.message || '必输项不能为空'));
  }
};
//大写英文字母和下划线组成
export function validateLetterAndUnderLine(rule, value, callback) {
  if (value != undefined) {
    value = value.toString().replace(/\s+/g, "");
    let rule2 = /^[A-Z_]{1,}$/;
    if (value != '' && value != null) {
      if(!rule2.test(value)){
        callback(new Error(rule.message));
      }else{
        callback();
      }
    } else {
      callback();
    }
  } else {
    callback();
  }
};
//备注的长度
export function validateLengthLimit(rule,value,callback){
  if(rule.lengthLimit == null){
    rule.lengthLimit = 32;
  }
  if (value != undefined) {
    value = value.toString().replace(/\s+/g, "");
    if (value != null && value.length>=rule.lengthLimit) {
      callback(new Error(rule.message || '只能输入'+rule.lengthLimit+'个以内的字符数目'));
    } else {
      callback();
    }
  }else{
    callback();
  }
};
export function validateLengthLimitAndNull(rule,value,callback){
  if (value != undefined) {
    value = value.toString().replace(/\s+/g, "");
    if(value == null || value.length<=0){
      callback(new Error(rule.message || '该选项不能为空'));
    }else if (value != null && value.length>=rule.lengthLimit) {
      callback(new Error(rule.message || '只能输入'+rule.lengthLimit+'个以内的字符数目'));
    } else {
      callback();
    } 
  }else{
    callback(new Error(rule.message || '该选项不能为空'));
  }
};
//数字且不为空的验证
export function validateNumAndNull(rule,value,callback){  
  if (value != undefined) {
    value = value.toString().replace(/\s+/g, "");
    if(value == null || value.length<=0){
      callback(new Error(rule.message || '该选项不能为空'));
    }else if (value != null && value!='' && !(/^\d+$/.test(value))) {
      callback(new Error(rule.message || '只能输入正数数字'));
    } else {
      callback();
    }
  }else{
    callback(new Error(rule.message || '必输项不能为空'));
  }
};
//手机号的验证
export function validateMobilePhone(rule,value,callback){  
  if(rule.message == undefined){
    rule.message = '输入正确格式的手机号码';
  }
  if (value != undefined) {
    value = value.toString().replace(/\s+/g, "");
    if (value != null && value!='' && !(/^1[34578]\d{9}$/.test(value))) {
      callback(new Error(rule.message || '请输入正确格式的手机号码'));
    } else {
      callback();
    }
  }else{
    callback();
  }
};
//纯数字的验证
export function validateNumber(rule,value,callback){  
  if (value != undefined) {
    value = value.toString().replace(/\s+/g, "");
    if (value != null && value!='' && !(/^[0-9]{1,}$/.test(value))) {
      callback(new Error(rule.message));
    } else {
      callback();
    }
  }else{
    callback();
  }
};
//MD5
export function validateMD5(rule,value,callback){ 
  if (value != undefined) {
    value = value.toString().replace(/\s+/g, "");
    if (value == '' || value == null || value.length!=32) {
      callback(new Error(rule.message || '请输入32位长度的MD5校验码'));
    } else {
      callback();
    }
  } else {
    callback(new Error(rule.message || '必输项不能为空'));
  }
};
//邮箱的验证
export function validateEmail(rule,value,callback){  
  if(rule.message == undefined){
    rule.message = '请输入正确格式的邮箱地址';
  }
  if (value != undefined) {
    value = value.toString().replace(/\s+/g, "");
    if (value != null && value!='' && !(/^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/.test(value))) {
      callback(new Error(rule.message || '请输入正确格式的邮箱地址'));
    } else {
      callback();
    }
  }else{
    callback();
  }
};
//身份证号的验证
export function validateIDnumber(rule,value,callback){  
  if (value != undefined) {
    value = value.toString().replace(/\s+/g, "");
    if (value != null && value!='' && !(/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(value))) {
      callback(new Error(rule.message || '请输入正确格式的身份证号'));
    } else {
      callback();
    }
  }else{
    // validateNullOrBlank(rule,value,callback);
    callback();
  }
};
//大写字母的验证
export function validateWordDa(rule,value,callback){  
  if (value != undefined) {
    value = value.toString().replace(/\s+/g, "");
    console.log('va:',value)
    if (value != null && value!='' && !(/^[A-Z_]{1,}$/.test(value))) {
      callback(new Error(rule.message || '请输入大写字母或下划线'));
    } else {
      callback();
    }
  }else{
    callback(new Error(rule.message || '该选项不能为空'));
  }
};
//数字的验证
export function validateNum(rule,value,callback){  
  if (value != undefined) {
    value = value.toString().replace(/\s+/g, "");
    console.log('va:',value)
    if (value != null && value!='' && !(/^[0-9]*[1-9][0-9]*$/.test(value))) {
      callback(new Error(rule.message || '只能输入正整数'));
    } else {
      callback();
    }
  }else{
    callback(new Error(rule.message || '该选项不能为空'));
  }
};



// WEBPACK FOOTER //
// ./src/common/utils/FormRules.js